<template>
    <MainContainer>
        <div class="buchung position-relative">
            <h2>
                Summen/Salden Liste
            </h2>
            <b-form>
                <b-form-group
                    label-for="inputYear"
                    :label-size="size"
                >
                    <template v-slot:label>
                        <template v-if="years.busy">
                            <ContentLoadingBlock class="inline" />
                        </template>
                        <template v-else>Gesamtes Abrechnungsjahr:</template>
                    </template>

                    <template v-if="years.busy">
                        <ContentLoadingBlock />
                    </template>
                    <template v-else>
                        <b-select
                            id="inputYear"
                            :options="years.options"
                            v-model="filter.year"
                            :size="size"
                        />
                    </template>
                </b-form-group>

                <b-form-row>
                    <b-col>
                        <b-form-group
                            label="Zeitraum von:"
                            label-for="inputFromDate"
                            :label-size="size"
                        >
                          <b-input
                              type="date"
                              id="inputFromDate"
                              v-model="filter._from_date"
                              :disabled="disableDateFilter"
                              :size="size"
                          />
                        </b-form-group>
                    </b-col>
                    <b-col>
                        <b-form-group
                            label="Zeitraum bis:"
                            label-for="inputToDate"
                            :label-size="size"
                        >
                          <b-input
                              type="date"
                              id="inputToDate"
                              v-model="filter._to_date"
                              :disabled="disableDateFilter"
                              :size="size"
                          />
                        </b-form-group>
                    </b-col>
                </b-form-row>

                <hr />

                <b-form-row>
                    <b-col>
                        <b-form-group
                            label-for="inputCols"
                            label="Zusätzliche Spalten:"
                            :label-size="size"
                        >
                          <CheckboxSelect
                              id="inputCols"
                              v-model="fields"
                              :options="additionalFields"
                              :size="size"
                          />
                        </b-form-group>
                    </b-col>
                    <b-col>
                        <b-form-group
                            label-for="inputInfos"
                            label="Zusätzliche Informationen:"
                            :label-size="size"
                        >
                          <CheckboxSelect
                              id="inputInfos"
                              v-model="information"
                              :options="additionalInformation"
                              :size="size"
                          />
                        </b-form-group>
                    </b-col>
                </b-form-row>

                <div class="d-flex justify-content-between">
                    <b-form-group>
                        <b-button variant="primary" @click="onSubmit" :size="size"
                        >
                            Anzeigen
                        </b-button
                        >
                        <b-button
                            type="reset"
                            variant="outline-danger"
                            :size="size"
                            class="ml-1"
                            @click="resetData"
                        >
                            Felder zurücksetzen
                        </b-button
                        >
                    </b-form-group>
                    <b-form-group>
                        <b-button
                            v-if="dataBuchungskonten.length > 0"
                            variant="primary"
                            :size="size"
                            @click="printSuSa"
                        >
                            Druckvorschau anzeigen
                        </b-button>
                    </b-form-group>
                </div>

            </b-form>
            <FiBuSuSaList
                title="Buchungskonten"
                :busy="busyBuchungskonten"
                :fields="fieldsForPresentation"
                :items="dataBuchungskonten"
            />
            <div
                class="list"
                v-if="
                    information.includes('finanzkonten') &&
                        dataFinanzkonten.length > 0
                "
            >
                <FiBuSuSaList
                    title="Finanzkonten"
                    :busy="busyFinanzkonten"
                    :fields="fieldsForFinanzkonto"
                    :items="dataFinanzkonten"
                />
            </div>
            <div class="list" v-if="information.includes('kategorien')">
                <FiBuSumCollection :filter="groupFilter" />
            </div>
        </div>
        <PopUpChecker />
        <div
            class="loading-modal container-fluid d-flex justify-content-center align-items-center p-3"
            v-if="busy"
        >
            <div class="d-flex flex-column align-items-center">
                <h6 class="mb-3">Daten werden geladen. Bitte haben Sie etwas Geduld!</h6>
                <b-spinner style="width: 3rem; height: 3rem;" label="Large Spinner"></b-spinner>
            </div>
        </div>
    </MainContainer>
</template>

<script>
import CommonView from "@/mixins/CommonView/CommonView";
import Size from "@/mixins/Size/Size";
import Currency from "@/mixins/Currency/Currency";
import Validation from "@/mixins/Validation/Validation";
import { ApiFactory } from "@/api/ApiFactory.js";
import MainContainer from "@/components/MainContainer/MainContainer";
import ContentLoadingBlock from "@/components/ContentLoadingBlock/ContentLoadingBlock";
import CheckboxSelect from "@/components/CheckboxSelect/CheckboxSelect";
import FiBuSuSaList from "@/components/FiBuSuSaList/FiBuSuSaList";
import FiBuSumCollection from "@/components/FiBuSumCollection/FiBuSumCollection";
import { BlobUtil } from "../../utils/BlobUtil";
import PopUpChecker from "@/components/PopUpChecker/PopUpChecker.vue";

const FiBuBuchungApi = ApiFactory.get("fibuBuchung");
const FiBuFinanzkontoApi = ApiFactory.get("fibuFinanzkonto");
const FiBuBuchungskontoApi = ApiFactory.get("fibuBuchungskonto");
const FiBuCategoryApi = ApiFactory.get("fibuCategory");
const FiBuSuSaApi = ApiFactory.get("fibuSusa");

export default {
    name: "SuSa",
    mixins: [CommonView, Size, Currency, Validation],
    components: {
        PopUpChecker,
        MainContainer,
        ContentLoadingBlock,
        CheckboxSelect,
        FiBuSuSaList,
        FiBuSumCollection
    },
    data() {
        return {
            api: FiBuBuchungApi,
            prefetch: false,
            fields: [],
            groupFilter: {},
            fieldsForPresentation: [],
            filtersForCategories: {},
            information: [],
            filter: { _from_date: null, _to_date: null, year: null },
            finanzkonto: {
                busy: false,
                items: [],
                options: []
            },
            buchungskonto: {
                busy: false,
                items: [],
                options: []
            },
            category: {
                busy: false,
                items: [],
                options: []
            },
            years: {
                busy: false,
                items: [],
                options: []
            },
            additionalFields: [
                { value: "sum_all_years", text: "Summe aller Jahre" },
                { value: "in_out", text: "Eingänge/Ausgänge" },
            ],
            additionalInformation: [
                { value: "finanzkonten", text: "Finanzkonten" },
                { value: "kategorien", text: "Kategorien" }
            ],
            disableDateFilter: false,
            dataFinanzkonten: [],
            busyFinanzkonten: false,
            dataBuchungskonten: [],
            busyBuchungskonten: false,
            busy: false
        };
    },
    async created() {
        this.fetchCategory();
        this.fetchFinanzkonto();
        this.fetchBuchungskonto();
        this.fetchBuchungsYears();

        this.filter.year = this.$moment()
            .format("Y");
    },
    watch: {
        "filter.year": {
            handler(val) {
                if (val) {
                    this.disableDateFilter = true;
                    this.filter._from_date = null;
                    this.filter._to_date = null;
                } else {
                    this.disableDateFilter = false;
                }
            }
        }
    },
    computed: {
        fieldsForFinanzkonto() {
          let finanzkontoFields = this.fieldsForPresentation.filter(val => val !== "sum_all_years");
          finanzkontoFields.push("endsum");
          return finanzkontoFields;
        },
    },
    methods: {
        async fetchSuSa() {
            FiBuSuSaApi.abort();

            if (this.information.includes("finanzkonten")) {
                this.busyFinanzkonten = true;
                FiBuSuSaApi.getFinanzkonten({
                    fields: this.fields,
                    filter: this.filter
                }).then(value => {
                    this.dataFinanzkonten = value.json.collection;
                    this.busyFinanzkonten = false;
                });
            }

            this.busyBuchungskonten = true;
            FiBuSuSaApi.getBuchungskonten({
                fields: this.fields,
                filter: this.filter
            }).then(value => {
                this.dataBuchungskonten = value.json.collection;
                this.busyBuchungskonten = false;
            });
        },
        async fetchFinanzkonto() {
            this.finanzkonto.busy = true;
            const response = await FiBuFinanzkontoApi.get();
            if (response.ok) {
                this.finanzkonto.items = response.json.collection;
                this.finanzkonto.options = response.json.collection.map(
                    item => {
                        return {
                            text: `${item.kontonr} - ${item.text}`,
                            value: item.id
                        };
                    }
                );
            }
            this.finanzkonto.busy = false;
        },
        async fetchBuchungskonto() {
            this.buchungskonto.busy = true;
            const response = await FiBuBuchungskontoApi.get();
            if (response.ok) {
                this.buchungskonto.items = response.json.collection;
                this.buchungskonto.options = response.json.collection.map(
                    item => {
                        return {
                            text: `${item.kontonr} - ${item.text}`,
                            value: item.id
                        };
                    }
                );
            }
            this.buchungskonto.busy = false;
        },
        async fetchCategory() {
            this.category.busy = true;
            const response = await FiBuCategoryApi.get();
            if (response.ok) {
                this.category.items = response.json.collection;
                this.category.options = response.json.collection.map(item => {
                    return {
                        text: item.description,
                        value: item.id
                    };
                });
            }
            this.category.busy = false;
        },
        async fetchBuchungsYears() {
            this.years.busy = true;
            const response = await FiBuBuchungApi.getYears();
            if (response.ok) {
                this.years.items = response.json.collection;
                this.years.options = response.json.collection.map(item => {
                    return {
                        text: item,
                        value: item
                    };
                });
                this.years.options.unshift({
                    text: "Datum auswählen...",
                    value: null
                });
            }
            this.years.busy = false;
        },
        updateFilter(filter) {
            this.filter = Object.assign({}, filter);
        },
        postProcessCreate(selectedItem, response) {
            selectedItem.id = response.json.id;
            return selectedItem;
        },
        fetchErrorHandling(response) {
            this.handleValidationData(response, this.ioFields);
        },
        postDataSet() {
            this.cleanValidationData(this.ioFields);
        },
        async onSubmit(evt) {
            evt.preventDefault();
            await this.fetchSuSa();
            this.fieldsForPresentation = [...this.fields];
            this.groupFilter = {...this.filter};
        },
        async printSuSa() {
            FiBuSuSaApi.abort();
            this.busy = true;

            const pages = this.$store.getters.getPages;

            const response = await FiBuSuSaApi.printSuSaView({
                filter: this.filter,
                fields: this.fields,
                finanzkonten: this.information.includes('finanzkonten') ? 1 : null,
                groupIds: this.information.includes('kategorien') ? pages.fibu_buchung.sumLists : null
            });

            if(response.ok) {
                const hasPopUpBlocker = BlobUtil.openBlob(response.blob);
                if (hasPopUpBlocker) {
                    this.$bvModal.show('pop-up-checker');
                }
            } else {
                this.makeToast(
                    'Keine Daten erhalten',
                    'Ein Fehler ist aufgetreten, bitte versuchen Sie es erneut.',
                    'danger'
                );
            }

            this.busy = false;
        },
        resetData() {
            this.fieldsForPresentation = [];
            this.dataBuchungskonten = [];
            this.dataFinanzkonten = [];
            this.groupFilter = {};
            this.information = [];
            this.filter = { _from_date: null, _to_date: null, year: null };
        }
    }
};
</script>
